'use strict';
import L from 'external/leaflet';

export default class MapScalePlugin {

    init(map, o) {
        map.addControl(L.control.scale({
            imperial: false,
            position: 'bottomright'
        }));
    }

}

MapScalePlugin.staticPlugin = true;



// WEBPACK FOOTER //
// ./js/plugins/MapScalePlugin.js